/** Returns true iff the URL is a network-safe http(s) URL. */
export const isWebUrl = (url: string | undefined): boolean => url !== undefined && /^https?:\/\//i.test(url);

/** Returns the preview src for a video attachment: iconUrl when present, falling back to the video URL. */
export const getVideoPreviewSrc = (attachment: { iconUrl?: string; url: string }): string =>
  attachment.iconUrl ?? attachment.url;
